'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'incidents_manager',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {
        persistBIM() {
            this.persistBIM();
        },
    },
});
